import {
  Container,
  ContentWrapper,
  LeftImageContainer,
  RightImageContainer,
  Text
} from './styles'
import SupportBannerButton from './SupportBannerButton'
import { SupportBannerProps } from './SupportBannerContainer.types'

const SupportBanner = ({
  des,
  button,
  leftBackgroundImageUrl,
  rightBackgroundImageUrl,
  style
}: SupportBannerProps) => {
  return (
    <Container style={style}>
      {leftBackgroundImageUrl && (
        <LeftImageContainer
          role='img'
          aria-label='left background image'
          backgroundImage={leftBackgroundImageUrl}
        />
      )}
      <ContentWrapper data-testid='content-wrapper'>
        <Text>{des}</Text>
        <SupportBannerButton button={button} />
      </ContentWrapper>
      {rightBackgroundImageUrl && (
        <RightImageContainer
          role='img'
          aria-label='right background image'
          backgroundImage={rightBackgroundImageUrl}
        />
      )}
    </Container>
  )
}

export default SupportBanner
